"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.errorMessages = exports["default"] = exports.NAME_MAX_LENGTH = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NAME_MAX_LENGTH = exports.NAME_MAX_LENGTH = 20;
var errorMessages = exports.errorMessages = {
  required: 'Name is required',
  length: "No more than ".concat(NAME_MAX_LENGTH, " characters"),
  regex: 'Accepts only letters, numbers, spaces and dashes'
};
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (!values.userName) {
    errors.userName = errorMessages.required;
  } else if (values.userName.length > NAME_MAX_LENGTH) {
    errors.userName = errorMessages.length;
  } else if (!/^[\w- ]+$/.test(values.userName)) {
    errors.userName = errorMessages.regex;
  }
  return errors;
};
var Picker = /*#__PURE__*/function (_React$Component) {
  _inherits(Picker, _React$Component);
  function Picker() {
    var _this;
    _classCallCheck(this, Picker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Picker, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      if (_this.props.valid) {
        _this.props.fields.changed.onChange(true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var DataConnectorsPicker = _this.props.DataConnectorsPicker;
      return /*#__PURE__*/_react["default"].createElement(DataConnectorsPicker, {
        elementId: 0,
        field: _this.props.fields.variable,
        type: ['string', 'number'],
        noModal: true,
        afterChange: _this.handleChange,
        topRender: /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
          field: _this.props.fields.userName,
          label: "Variable name"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "text",
          className: "form-control input-sm"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this.props.fields.userName), {
          style: {
            maxWidth: '200px'
          },
          maxLength: NAME_MAX_LENGTH,
          autoFocus: true,
          placeholder: "e.g. Student name"
        })))
      });
    });
    return _this;
  }
  _createClass(Picker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldValue = prevProps.fields.changed.value;
      var newValue = this.props.fields.changed.value;
      if (oldValue !== newValue) {
        this.props.handleSubmit();
      }
    }
  }]);
  return Picker;
}(_react["default"].Component);
_defineProperty(Picker, "propTypes", {
  DataConnectorsPicker: _propTypes["default"].func,
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  valid: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'variablePicker',
  fields: ['variable', 'userName', 'changed'],
  validate: validate
})(Picker);